import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaCheckCircle, FaTimes, FaRegStar, FaDollarSign } from "react-icons/fa";
import Loader from "../../Common/Loader/loader";

const ViewSubscriptionPage = () => {
  const [subscriptionData, setSubscriptionData] = useState({});
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await axios.get(
          `${process.env.REACT_APP_API_PATH}/subscription_plan/get_subscription_plan?planId=${state.plan}`
        );
        setSubscriptionData(result.data?.data || {});
        setLoading(false);
      } catch (error) {
        console.error("Error fetching subscription details:", error);
      }

    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getSubscriptionBadge = (type) => {
    switch (type) {
      case "FREE":
        return { bg: "#FFF4E0", color: "#FF9F00", icon: <FaDollarSign /> };
      case "BASIC":
        return { bg: "#E0F0FF", color: "#286A94", icon: <FaRegStar /> };
      case "ENTERPRISE":
        return { bg: "#E6F4EA", color: "#007D3B", icon: <FaRegStar /> };
      default:
        return { bg: "#F0F0F0", color: "#666", icon: <FaRegStar /> };
    }
  };

  const infoItems = [
    { label: "Subscription ID", value: subscriptionData?.planId },
    { label: "Price (Monthly)", value: subscriptionData?.price ? `${subscriptionData.price} Rs` : "N/A" },
    ...(subscriptionData?.discountPercentage
      ? [{ label: "Discounted Price", value: `${subscriptionData?.discountedPrice} Rs` }]
      : []),
    {
      label: "Subscription Type",
      value: (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "4px 10px",
            borderRadius: 12,
            fontWeight: 500,
            fontSize: 12,
            backgroundColor: getSubscriptionBadge(subscriptionData?.subscriptionType)?.bg,
            color: getSubscriptionBadge(subscriptionData?.subscriptionType)?.color,
          }}
        >
          {getSubscriptionBadge(subscriptionData?.subscriptionType)?.icon}
          {subscriptionData?.subscriptionType || "N/A"}
        </span>
      ),
    },
    {
      label: "Status",
      value: subscriptionData?.status ? (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "4px 10px",
            borderRadius: 12,
            fontWeight: 500,
            fontSize: 12,
            color: "#007d3b",
            backgroundColor: "#cbffe1",
          }}
        >
          <FaCheckCircle />
          Active
        </span>
      ) : (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "4px 10px",
            borderRadius: 12,
            fontWeight: 500,
            fontSize: 12,
            color: "#a50000",
            backgroundColor: "#ffd6d6",
          }}
        >
          <FaTimes />
          Expired
        </span>
      ),
    },
    { label: "Max Apply Jobs (Monthly)", value: subscriptionData?.maxApplications || 0 },
    ...(subscriptionData?.userType === "VENDOR"
      ? [
          { label: "Max Jobs Posted (Monthly)", value: subscriptionData?.maxJobs || 0 },
          { label: "Max Team Members (Monthly)", value: subscriptionData?.maxTeamMembers || 0 },
          { label: "Max Interviews Scheduled (Monthly)", value: subscriptionData?.maxInterviews || 0 },
        ]
      : []),
    { label: "Monthly Discount %", value: subscriptionData?.discountPercentageList?.MONTHLY || "0%" },
    { label: "Quarterly Discount %", value: subscriptionData?.discountPercentageList?.QUARTERLY || "0%" },
    { label: "Half Yearly Discount %", value: subscriptionData?.discountPercentageList?.HALF_YEARLY || "0%" },
    { label: "Yearly Discount %", value: subscriptionData?.discountPercentageList?.YEARLY || "0%" },
  ];

  if (loading) {
    return (
      <div style={{ height: "70vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader />
      </div>
    )
  }

  return (
    <div className="container" style={{ marginTop: 30, marginBottom: 50 }}>
      <div
        style={{
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          borderRadius: 12,
          overflow: "hidden",
          backgroundColor: "#fff",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "16px 24px",
            backgroundColor: "#286A94",
            color: "#fff",
            fontWeight: 600,
            fontSize: 20,
          }}
        >
          Subscription Plan Details
        </div>

        {/* Content Grid */}
        <div style={{ padding: 24 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: width > 600 ? "repeat(auto-fit, minmax(250px, 1fr))" : "repeat(auto-fit, minmax(200px, 1fr))",
              gap: 16,
            }}
          >
            {infoItems.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: 16,
                  borderRadius: 10,
                  backgroundColor: "#f9f9f9",
                  transition: "all 0.2s",
                  cursor: "default",
                }}
                className="hover-card"
              >
                <span style={{ fontSize: 13, color: "rgba(0,0,0,0.6)", marginBottom: 6 }}>{item.label}</span>
                <span style={{ fontSize: 15, fontWeight: 500 }}>{item.value || "N/A"}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSubscriptionPage;
